<template>
  <v-card>
    <v-card-title>
      <div class="heading">Группа {{ group.name }}</div>
    </v-card-title>
    <v-card-text>
      <v-form ref="groupForm">
        <v-row>
          <v-col cols="6"
            ><v-text-field v-model="group.name" name="name" label="Название группы"></v-text-field
          ></v-col>
          <v-col cols="6">
            <v-text-field
              v-model="group.group_id"
              name="group_id"
              label="Идентификатор группы (id)"
              type="number"
            ></v-text-field
          ></v-col>
          <v-col cols="6">
            <v-text-field
              v-model="group.confirmation_key"
              name="confirmation_key"
              label="Строка, которую должен вернуть сервер"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <div class="heading">Секретный ключ</div>
            <v-btn icon @click="copyClipboard" color="primary">
              <v-icon>mdi-content-copy</v-icon>
            </v-btn>
            <span>{{ group.secret_key }}</span></v-col
          >
        </v-row>
        <v-row>
          <v-col cols="6">
            <v-btn color="green" dark @click="save" :disabled="loading">Сохранить</v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'VKGroup',
  props: {
    groupId: { type: String, default: '' },
  },
  data() {
    return {
      group: {
        name: '',
        group_id: 0,
        confirmation_key: '',
        secret_key: '',
      },
      loading: false,
    }
  },
  computed: {
    isEdit() {
      return !!this.group.id || !!this.groupId
    },
  },
  mounted() {
    if (this.isEdit) {
      this.getGroupData()
    }
  },
  methods: {
    copyClipboard() {
      const el = document.createElement('textarea')
      el.value = this.group.secret_key
      document.body.appendChild(el)
      el.select()
      document.execCommand('copy')
      document.body.removeChild(el)
      this.showSnackbar('Скопировано', 'green')
    },
    getGroupData() {
      this.axios({
        url: `/v1/integrations/vk/groups/${this.$route.params.id}`,
        method: 'get',
      })
        .then((resp) => {
          this.group = resp.data
        })
        .catch((err) => {
          this.$log.error('get vk group', err)
          this.showSnackbar(err.response ? err.response.data : err, 'error')
        })
    },
    save() {
      if (!this.$refs.groupForm.validate()) {
        this.showSnackbar('Исправьте ошибки', 'error')
        return
      }
      this.loading = true
      this.group.group_id = Number(this.group.group_id)
      const url = this.isEdit
        ? `/v1/integrations/vk/groups/${this.group.id}`
        : '/v1/integrations/vk/groups'
      this.axios({
        url: url,
        method: this.isEdit ? 'put' : 'post',
        data: this.group,
      })
        .then((resp) => {
          this.group = resp.data
          this.$emit('vk-group-update', this.group)
          this.showSnackbar('Сохранено', 'green')
        })
        .catch((err) => {
          this.showSnackbar(err.response.data, 'error')
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>
